import { injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { Environment } from "src/libs/environment";
import { PgaPolicy } from "src/shared/models/pga-policy.model";

@injectable()
export class HealthCarnetService {
    @autoBind
    isPolicyAllowed(policy: PgaPolicy): boolean {
        return policy.product.features.healthCard;
    }

    @autoBind
    validateAccess(policies: Array<PgaPolicy>): boolean {
        const isEnabled = Environment.bool("HEALTH_TRAVELER_CARNET_FEATURE_ON");
        const allowedPolicies = policies.some(this.isPolicyAllowed);
        return isEnabled && allowedPolicies;
    }
}
